import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OutlineItem } from './PageNav';

type Props = {
  item: OutlineItem;
  handleClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  newNav: boolean;
};

export class NavItem extends React.Component<Props> {
  render() {
    const { item, handleClick, newNav } = this.props;
    return (
      <div
        onClick={handleClick}
        className={`page-nav${newNav ? '__new-domain' : '__domain'} pointer`}
      >
        <div>
          {item.text ||
            (item.textId ? <FormattedMessage id={item.textId} /> : '')}
        </div>
      </div>
    );
  }
}
